var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegendAux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 13.2C7.93137 13.2 8.2 12.9314 8.2 12.6C8.2 12.2686 7.93137 12 7.6 12C7.26863 12 7 12.2686 7 12.6C7 12.9314 7.26863 13.2 7.6 13.2Z",
    stroke: "currentColor",
    strokeWidth: 2.1667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 13.2C13.1313 13.2 13.4 12.9314 13.4 12.6C13.4 12.2686 13.1313 12 12.8 12C12.4686 12 12.2 12.2686 12.2 12.6C12.2 12.9314 12.4686 13.2 12.8 13.2Z",
    stroke: "currentColor",
    strokeWidth: 2.1667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.2C18.3314 13.2 18.6 12.9314 18.6 12.6C18.6 12.2686 18.3314 12 18 12C17.6687 12 17.4 12.2686 17.4 12.6C17.4 12.9314 17.6687 13.2 18 13.2Z",
    stroke: "currentColor",
    strokeWidth: 2.1667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3C20.5102 3 22.5 4.89031 22.5 12.75C22.5 20.6097 20.5102 22.5 12.75 22.5C4.9898 22.5 3 20.5102 3 12.75C3 4.9898 4.9898 3 12.75 3Z",
    stroke: "currentColor",
    strokeWidth: 2.1667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendAux);
export default __webpack_public_path__ + "static/media/LegendAUX.34f0dc5b09008db18f7e5c65cbd14213.svg";
export { ForwardRef as ReactComponent };